module.exports = __webpack_public_path__ + "img/contact16.9bb80899.png";